export default "__VITE_ASSET__BVPUBywK__"